// src/stone/icons/Coil.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Coil = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M8 2C5.06 2 3 3.954 3 6s2.06 4 5 4 5-1.954 5-4-2.06-4-5-4M1 6c0-3.477 3.312-6 7-6s7 2.523 7 6-3.312 6-7 6-7-2.523-7-6" }),
      /* @__PURE__ */ jsx("path", { d: "M9 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0" }),
      /* @__PURE__ */ jsx("path", { d: "M6 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0M4.312 20.996C5.212 21.596 6.513 22 8 22s2.788-.404 3.688-1.004C12.595 20.392 13 19.666 13 19h2c0 1.543-.938 2.817-2.203 3.66C11.526 23.508 9.827 24 8 24s-3.526-.492-4.797-1.34C1.938 21.818 1 20.543 1 19h2c0 .666.405 1.392 1.312 1.996M1 19V6h2v13zM13 19V6h2v13z" }),
      /* @__PURE__ */ jsx("path", { d: "M20.523 2H8V0h15.477l-1.392 3.48 1.01 2.27-1.01 2.27.992 2.48-.992 2.48 1.01 2.27-1.01 2.27L23.477 21h-9.096v-2h6.142l-.608-1.52.99-2.23-.99-2.23 1.008-2.52-1.008-2.52.99-2.23-.99-2.23z" })
    ]
  }
);
var Coil_default = Coil;

export {
  Coil,
  Coil_default
};
